import React from 'react';
import { useParams } from 'react-router-dom';

const BlogPost = () => {
  const { id } = useParams();
  return (
    <div className="min-h-screen bg-zinc-900 py-24">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-4" style={{fontFamily: 'Syne, sans-serif'}}>Artículo de Blog</h1>
        <p className="text-zinc-400">Contenido del artículo {id}</p>
      </div>
    </div>
  );
};

export default BlogPost;